/* ==========================================================================
   SERPROMAQ - SISTEMA DE SCROLL POR SECCIONES & PUNTOS A LA IZQUIERDA
   ========================================================================== */

const SECTION_METADATA = {
  'inicio': 'Inicio',
  'pilares': 'Servicios Core',
  'servicios': 'Catálogo de Maquinaria',
  'talento': 'Vacantes y Talento',
  'portal-postulacion': 'Portal de Postulación',
  'nosotros': 'Nosotros y Política',
  'testimonios': 'Casos de Éxito',
  'contacto': 'Contacto y Ubicación',
  'footer': 'Información Corporativa'
};

export function initFullPageScroll() {
  const sections = document.querySelectorAll('.snap-section');
  if (sections.length === 0) return;

  const sideDotsNav = document.getElementById('sideDotsNav');
  const bottomScrollCue = document.getElementById('bottomScrollCue');
  const bottomChevron = document.getElementById('bottomScrollChevron');

  let isScrolling = false;
  let currentIndex = 0;
  const cooldownTime = 850; // ms entre desplazamientos para evitar saltos múltiples
  const totalSections = sections.length;

  // 1. Renderizar Puntos Verticales en el Lateral Izquierdo
  if (sideDotsNav) {
    sideDotsNav.innerHTML = Array.from(sections).map((section, index) => {
      const sectionId = section.getAttribute('id') || (section.tagName.toLowerCase() === 'footer' ? 'footer' : `seccion-${index + 1}`);
      const title = SECTION_METADATA[sectionId] || `Sección ${index + 1}`;
      return `
        <div class="side-dot-item">
          <button class="side-dot ${index === 0 ? 'active' : ''}" data-index="${index}" aria-label="Ir a ${title}"></button>
          <span class="side-dot-tooltip">${title}</span>
        </div>
      `;
    }).join('');

    sideDotsNav.querySelectorAll('.side-dot').forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const targetIndex = parseInt(dot.getAttribute('data-index'), 10);
        scrollToSection(targetIndex);
      });
    });
  }

  // 2. Actualizar estado activo de los puntos, navbar y del indicador inferior
  function updateIndicator(index) {
    if (index < 0 || index >= totalSections) return;
    currentIndex = index;

    // Actualizar puntos de la barra izquierda
    if (sideDotsNav) {
      const dots = sideDotsNav.querySelectorAll('.side-dot');
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    // Actualizar enlaces activos de la barra de navegación superior y drawer móvil
    const activeSection = sections[index];
    const sectionId = activeSection ? activeSection.getAttribute('id') : null;
    if (sectionId) {
      document.querySelectorAll('.nav-link, .drawer-link').forEach(link => {
        const href = link.getAttribute('href');
        if (href === `#${sectionId}`) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }

    // Actualizar clase activa en las secciones para disparar animaciones en cascada
    sections.forEach((sec, i) => {
      if (i === index) {
        sec.classList.remove('active-in-view');
        void sec.offsetWidth; // Forzar reflow para reiniciar la animación
        sec.classList.add('active-in-view');
        sec.classList.add('revealed');
      } else {
        sec.classList.remove('active-in-view');
        // Si no es la sección activa, asegurar que sus videos internos se detengan
        const inactiveVideos = sec.querySelectorAll('video');
        inactiveVideos.forEach(v => {
          if (!v.paused) {
            v.pause();
          }
        });
      }
    });

    // Actualizar flecha del indicador inferior minimalista
    if (bottomChevron && bottomScrollCue) {
      if (index >= totalSections - 1) {
        bottomChevron.className = 'fa-solid fa-chevron-up minimal-chevron';
        bottomScrollCue.title = 'Haz clic para volver al inicio';
      } else {
        bottomChevron.className = 'fa-solid fa-chevron-down minimal-chevron';
        bottomScrollCue.title = 'Gira la rueda del ratón o pulsa para bajar a la siguiente sección';
      }
    }
  }

  // Obtener la sección más cercana al viewport actualmente
  function getCurrentSectionIndex() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    let closestIndex = 0;
    let minDistance = Infinity;

    sections.forEach((section, index) => {
      const distance = Math.abs(section.offsetTop - scrollY);
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function scrollToSection(index) {
    if (index < 0 || index >= totalSections) return;

    isScrolling = true;
    updateIndicator(index);

    const targetSection = sections[index];
    const targetTop = targetSection.offsetTop;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });

    // Actualizar el hash de la URL si tiene ID
    const sectionId = targetSection.getAttribute('id');
    if (sectionId) {
      history.pushState(null, '', `#${sectionId}`);
    }

    setTimeout(() => {
      isScrolling = false;
    }, cooldownTime);
  }

  // Click en el Indicador Minimalista Inferior Central
  if (bottomScrollCue) {
    bottomScrollCue.addEventListener('click', () => {
      const current = getCurrentSectionIndex();
      if (current >= totalSections - 1) {
        scrollToSection(0); // Volver al inicio
      } else {
        scrollToSection(current + 1); // Bajar a la siguiente
      }
    });
  }

  // 3. Control de Rueda del Ratón (Wheel) - Solo en Escritorio (>= 992px)
  window.addEventListener('wheel', (e) => {
    if (window.innerWidth < 992) return;
    if (document.body.style.overflow === 'hidden') return;
    if (e.target.closest('.modal-container') || e.target.closest('.mobile-drawer')) return;

    if (isScrolling) {
      e.preventDefault();
      return;
    }

    const delta = e.deltaY;
    const current = getCurrentSectionIndex();

    if (Math.abs(delta) > 25) {
      if (delta > 0 && current < totalSections - 1) {
        e.preventDefault();
        scrollToSection(current + 1);
      } else if (delta < 0 && current > 0) {
        e.preventDefault();
        scrollToSection(current - 1);
      }
    }
  }, { passive: false });

  // 4. Control por Teclado (Solo en Escritorio >= 992px)
  window.addEventListener('keydown', (e) => {
    if (window.innerWidth < 992) return;
    if (document.body.style.overflow === 'hidden') return;
    if (['input', 'textarea', 'select'].includes(document.activeElement.tagName.toLowerCase())) return;

    const current = getCurrentSectionIndex();

    if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') {
      if (current < totalSections - 1) {
        e.preventDefault();
        scrollToSection(current + 1);
      }
    } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
      if (current > 0) {
        e.preventDefault();
        scrollToSection(current - 1);
      }
    }
  });

  // 5. En móviles (< 992px), permitimos scroll vertical natural continuo sin restricciones
  // mientras el scroll listener pasivo actualiza la sección activa en el menú.

  // 6. Scroll Listener pasivo
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      if (!isScrolling) {
        const activeIndex = getCurrentSectionIndex();
        updateIndicator(activeIndex);
      }
    }, 100);
  }, { passive: true });

  // Inicializar estado activo
  updateIndicator(getCurrentSectionIndex());
}
